import { languageFallback, languages } from '@/const/shared'

export function getLangWithUrl(routeLang) {
  const lang = languages.find(lang => lang.url === routeLang)
  return lang || languageFallback
}
